<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BasicInfoForms',
})
</script>
<template>
  <Row :gutter="16">
    <Col :xxl="4" :xl="6" :span="8">
      <FormItem label="所属村组" name="village" :rules="getRequiredRule('所属村组')">
        <CommonSelect
          :immediate="false"
          v-model:value="model.village"
          :api="fetchVillageOptions"
          :params="pId"
          showSearch
          allowClear
          placeholder="请选择"
        />
      </FormItem>
    </Col>
    <Col :xxl="4" :xl="6" :span="8">
      <FormItem label="家庭人口" name="memberNumber" :rules="getRequiredRule('家庭人口')">
        <InputNumber v-model:value="model.memberNumber" :min="0" :step="1" :precision="0" placeholder="请输入" allow-clear />
      </FormItem>
    </Col>
    <!-- <Col :xxl="4" :xl="6" :span="8">
      <FormItem label="征拆户编号" name="zhengchaihubianhao" :rules="getRequiredRule('征拆户编号')">
        <Input v-model:value="model.zhengchaihubianhao" placeholder="请输入" allow-clear />
      </FormItem>
    </Col> -->
    <Col :xxl="4" :xl="6" :span="8">
      <FormItem label="联系人" name="contactName">
        <Input v-model:value="model.contactName" placeholder="请输入" allow-clear />
      </FormItem>
    </Col>
    <Col :xxl="4" :xl="6" :span="8">
      <FormItem label="联系方式" name="contactPhone">
        <Input v-model:value="model.contactPhone" placeholder="请输入" allow-clear />
      </FormItem>
    </Col>
    <Col :span="24">
      <FormItem label="地址" name="addressCoordinate">
        <TMapMarkerPicker v-model:value="model.addressCoordinate" @change="handleAddressUpdate" />
      </FormItem>
    </Col>
    <Col :span="24">
      <FormItem label="详细地址" name="addressDetail" :rules="getRequiredRule('详细地址')">
        <Input v-model:value="model.addressDetail" placeholder="请输入" allow-clear />
      </FormItem>
    </Col>
    <Col :span="24">
      <FormItem label="户口本" name="memberFiles">
        <FileUpload v-model:value="model.memberFiles" />
      </FormItem>
    </Col>
  </Row>
</template>

<script lang="ts" setup name="BasicInfoForms">
import { Col, Input, InputNumber, Row } from 'ant-design-vue'
import { toRef } from 'vue'
import { FileUpload } from '-/Common/FileUpload'
import { FormItem } from '-/Common/Form'
import { Select as CommonSelect } from '-/Common/Select'
import { TMapMarkerPicker } from '-/Base/TMap'
import { getRequiredRule } from '@/constant/form'
import { API_JT_PROJ_VILLAGE_LIST } from '@/api/jtProj'

const props = defineProps<{
  dataSync?: Partial<ApiJtZch.BasicInfoData>
  pId?: string
}>()
const model = toRef(props, 'dataSync', {})
/** 获取所属村组选项 */
const fetchVillageOptions = async id => {
  const res = await API_JT_PROJ_VILLAGE_LIST(id)
  const uniqueRes = Array.from(new Set(res))
  return uniqueRes.map(label => ({
    label,
    value: label
  }))
}
/** 地图选点之后, 更新地址信息 */
const handleAddressUpdate = (_, address?: string) => {
  if (address) {
    model.value.addressDetail = address
  }
}
</script>

<style lang="less" scoped>
.ant-select,
.ant-picker,
.ant-input-number,
.ant-input-number-group-wrapper {
  width: 100%;
}
</style>
